<div class="navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content pb-5 pt-1" style="padding: 0px;">
  <div *ngIf="slides && slides.length > 0" class="col-xg-12 col-lg-12 col-md-12 col-xs-12 photos-modal-hotel" style="border-radius: 6px; padding: 0px; background-color: #fff">
    <div class="custom-carousel-wrapper">
      <!-- Switch Videos - Fotos (solo si hay mezcla) -->
      <div class="photos-media-switch" *ngIf="(videos && videos.length > 0) || (images && images.length > 0)">
        <div class="photos-media-switch-inner">
          <button class="usb-modal-experience-btn-icon"
                  [class.usb-modal-experience-btn-icon-active]="isCurrentVideo()"
                  (click)="goToNextOfType('video')"
                  title="Próximo video">
            <img width="20" height="20" src="../../../../assets/icons/itinerary/video_inst.svg" alt="video" />
          </button>
          <button class="usb-modal-experience-btn-icon"
                  [class.usb-modal-experience-btn-icon-active]="!isCurrentVideo()"
                  (click)="goToNextOfType('image')"
                  title="Próxima foto">
            <img width="20" height="20" src="../../../../../assets/icons/modals/modal-tours/video-01.svg" alt="foto" />
          </button>
          <p class="mb-0 usb-modal-experience-text extra-small bold" *ngIf="slides && slides.length > 0">
            + de {{ slides.length > 1 ? slides.length - 1 : '1' }} {{ isCurrentVideo() ? 'videos' : 'fotos' }}
          </p>
        </div>
      </div>

      <div class="custom-carousel-container" *ngIf="slides && slides.length > 0">
        <div class="custom-carousel-track" #carouselTrack (scroll)="onScroll()">
          <div class="custom-carousel-slide"
              *ngFor="let img of duplicatedImages; let i = index"
              [attr.data-index]="i"
              [class.active]="(i % slides.length) === currentIndex"
              (click)="selectImage(i % slides.length)">
            <ng-container *ngIf="!isVideo(img); else videoTpl">
              <img [src]="getItemSrc(img)"
                  [alt]="img.description || 'Imagen del hotel'"
                  onerror="if (this.src != 'assets/img/app/hotel_default.png') this.src = 'assets/img/app/hotel_default.png';">
            </ng-container>
            <ng-template #videoTpl>
              <video [src]="getItemSrc(img)" controls preload="metadata" (click)="$event.stopPropagation()"></video>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Círculos con números y puntos suspensivos - Sliding Window -->
      <div class="custom-carousel-dots-numbered" *ngIf="slides && slides.length > 0">
        <div class="dots-numbered-wrapper">
          <!-- Flecha izquierda -->
          <button class="nav-arrow prev-arrow" (click)="prevImage()" [disabled]="loading">
                 <i class="bi bi-caret-left-fill"></i>
          </button>

          <!-- Círculos numerados dinámicos -->
          <div class="dots-numbered-container">
            <div *ngFor="let dot of getVisibleDots(); trackBy: trackByDot"
                class="dot-numbered"
                [ngStyle]="{'color': !dot.isEllipsis && currentIndex === dot.index ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : 'black'}"
                [class.active]="!dot.isEllipsis && currentIndex === dot.index"
                [class.ellipsis-dot]="dot.isEllipsis"
                (click)="!dot.isEllipsis && selectImage(dot.index)">
              {{ dot.label }}
            </div>
          </div>

          <!-- Flecha derecha -->
          <button class="nav-arrow next-arrow" (click)="nextImage()" [disabled]="loading">
            <i class="bi bi-caret-right-fill"></i>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="slides && slides.length === 0" class="col-xg-12 col-lg-12 col-md-12 col-xs-12 photos-modal-hotel" style="border-radius: 6px; padding: 0px; border: 1px solid #ccc; background-color: #fff">
      <div class="d-flex justify-content-center align-items-center" style="height: 450px;">
        <p class="semiblack" style="font-family: 'Rubik', serif; font-size: 28px; font-weight: 600;">No hay fotos para este producto</p>
      </div>
    </div>
  </div>
</div>
